module.exports = __webpack_public_path__ + "6856e1e388f9649837381eb5decd3e18.pdf";